// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/home_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 600px) {
    .OmL0k1siDBYnZFcDCGRA {
        min-height: 100vh;
        padding: 20px;
        font-family: "Nunito Sans", sans-serif;
        background-color: #f5f5f5;
        margin-top: -4rem;
    }

    .Tv6qA2o9NmhzzT6moi3l {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .aCuUKL3tNvTSewk9CUI5 {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .E7N4bcgOnRZlI91eZLjE {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: white;
    }

    .SlKxh3LdKUwkgx8hUb3N {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 2px;
    }

    .HvyUkA3pUczA5sLQGEhj {
        font-size: 15px;
        font-weight: 600;
        color: rgba(33, 33, 33, 1);
        font-family: 'Nunito Sans', Sans-serif, serif;
    }

    .faujMG9wZP2vYdw0M1vq {
        font-size: 14px;
        color: rgba(77, 77, 77, 1);
        margin-top: 2px;
        font-weight: 400;
        font-family: 'Nunito Sans', Sans-serif, serif;
    }

    .AaX1fIXYpfSeoFerwDaf {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        margin-top: -6%;
        gap: 10px;
    }

    .QJ5m6ojPbeSpGPsT9MYW {
        height: 20px;
        color: rgba(77, 77, 77, 1);
        background-color: rgba(245, 245, 245, 1);
        padding: 7px;
        border: 0 solid #555555;
        border-radius: 16px;
        cursor: pointer;
    }

    .pls963bgjTppYESE8Evm {
        display: flex;
        flex-direction: column;
        gap: -8px;
    }

    .Z9xrRCkgWPPSvCSedC4o {
        padding: 15px;
        padding-top: 20px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-top: 25px;
        width: 91%;
    }

    .CZbtrATtIdUaSS30xFQq {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .BUceoThRp7MbfiTpW8iX {
        display: flex;
        gap: 10px;
        margin-right: 55%;
    }

    .AmlqCwQvuhtuYtDOpVrl {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .ivmIKCTwLmdYEF0RVBgL {
        font-size: 18px;
        color: rgba(0, 75, 160, 1);
        font-weight: 700;
        margin: 25px 0 5px;
        cursor: pointer;
        font-family: 'Nunito Sans', Sans-serif, serif;

    }

    .yzGPhd7CjYvNTY6ssK2X {
        font-size: 14px;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        margin: 5px 0 0;
        line-height: 1.5;
        font-family: 'Nunito Sans', Sans-serif, serif;
    }

    .n5jnNnco_orTsH6WNyZU {
        font-weight: bold;
        margin-left: 54%;
        color: black;
        background-color: rgba(245, 245, 245, 1);
        padding: 9px 19px;
        border-radius: 16px;
        font-size: 12px;
    }

    .l9Mro0JLxxkpw3vc0VsQ .AaX1fIXYpfSeoFerwDaf {
        border-radius: 5px;
        padding: 5px;
        font-size: 14px;
        color: #757575;
        margin-top: -25px;
    }

    .l9Mro0JLxxkpw3vc0VsQ .QJ5m6ojPbeSpGPsT9MYW {
        width: 20px;
        height: 20px;
    }

    .cDTrdXn9Jgcx5vBtquAN .AaX1fIXYpfSeoFerwDaf {
        background-color: #ffffff;
        margin-top: -43px;
    }

    .cDTrdXn9Jgcx5vBtquAN .QJ5m6ojPbeSpGPsT9MYW {
        width: 16px;
        height: 16px;
    }

    .n7cACY4adqQcH0HLUluf {
        height: 20px;
        width: 100%;
        font-size: 10px;
        color: lightslategray;
        font-weight: bold;
        margin-top: 10px;
        display: inline-block;
    }
    .MAR7sEF73jMtrgpXm2Gd {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        top: 20px;
        padding-bottom: 15px;
        width: 100%;
    }

    .HOxveBXEo4M2dA77bQLH {
        position: absolute;
        left: 16px;
        top: 2%;
        cursor: pointer;
    }

    .Kv42rkZok22_plGpHFmU,
    .HOxveBXEo4M2dA77bQLH {
        height: 36px;
    }

    .Kv42rkZok22_plGpHFmU {
        margin: 0 auto;
        display: block;
    }

    .ZMBhr4sIHOeShyiFhZ3d {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid white;
        border-radius: 35px;
        width: 95%;
        margin: 15% auto;
        gap: 6px;
        background-color: rgba(255, 255, 255, 1);
        height: 52px;
    }

    .ZMBhr4sIHOeShyiFhZ3d p {
        font-family: "Nunito Sans", sans-serif;
        color: rgba(77, 77, 77, 1);
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 20px;
    }

    .ZMBhr4sIHOeShyiFhZ3d p.stVkduZD3MUjoXboSTgk {
        background-color: rgba(25, 118, 210, 0.12);
        color: #1976D2;
        padding: 10px 16px;
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }

    .ZMBhr4sIHOeShyiFhZ3d p:hover {
        background-color: rgba(25, 118, 210, 0.08);
        color: #135ba0;
    }

}



.aDkAGkcAr4kipXJWr846 {
    margin-top: -25px;
    background-color: #F5F5F5;
    position: relative;
}
.tV8D8bekuMLBItOytzPC {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: white;
    cursor: pointer;
}
.Z886TPaOVv9Slu5UxMdg{
    background-image: linear-gradient(rgba(0, 0, 0.6, 0.6), rgba(0, 0, 0.6, 0.6)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-color: #F5F5F5;
    margin: 0 auto 60px auto;
    width: 90%;
    border-radius: 10px;
    height: 230px;
    background-repeat: no-repeat;
    object-fit: cover;
    background-size: 100%;
    text-align: center;
}
.m5VIelB54f6NAoS_9kIR{
    color: white;
    font-size: 40px;
    font-weight: bold;
    margin: 0;
    font-family: sans-serif;
}
.cNpPzvaE13owUS_z5sMF{
    color: lightgrey;
}
.BnCccvejn0Izkne6dwj4{
    color: ghostwhite;
    margin-bottom: 20px;
}
.CUUi3lMEOplbshk0BMqh{
    padding: 10px 0;
    margin: 0;
    text-align: center;
}
.h2t_7THSlfsAwV5H_spW {
    display: flex;
    justify-content: center;
    margin: 10px 0 20px 0;
}
.GLfLORnKxMSSDmrutRjf {
    display: flex;
    padding: 0 80px 40px 80px;
    gap: 20px;
    justify-content: center;
    overflow: hidden;
}
.nSKs8tl3O6dhGzhQSVpP {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.A7ivpXKRI8lCuJezktV_ {
    font-size: 14px;
    padding: 10px;
    line-height: 5px;
    text-align: center;
    background-color: white;
    border-radius: 15px;
}
.IH40yGfeI8pO2Rjv3DHP {
    background-color: white;
    height: 38px;
    border-radius: 22px;
}
.HNr6iN3rXKpb9Ye0qfeZ {
    display: none;
}

`, "",{"version":3,"sources":["webpack://./src/home/css/community.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,sCAAsC;QACtC,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,0BAA0B;QAC1B,6CAA6C;IACjD;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,eAAe;QACf,gBAAgB;QAChB,6CAA6C;IACjD;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,eAAe;QACf,eAAe;QACf,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,0BAA0B;QAC1B,wCAAwC;QACxC,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,sBAAsB;QACtB,mBAAmB;QACnB,wCAAwC;QACxC,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,6CAA6C;;IAEjD;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,0BAA0B;QAC1B,eAAe;QACf,gBAAgB;QAChB,6CAA6C;IACjD;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,wCAAwC;QACxC,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,qBAAqB;QACrB,iBAAiB;QACjB,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;QAClB,SAAS;QACT,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,OAAO;QACP,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,QAAQ;QACR,wCAAwC;QACxC,YAAY;IAChB;;IAEA;QACI,sCAAsC;QACtC,0BAA0B;QAC1B,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,0CAA0C;QAC1C,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,wCAAwC;IAC5C;;IAEA;QACI,0CAA0C;QAC1C,cAAc;IAClB;;AAEJ;;;;AAIA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sHAAwH;IACxH,yBAAyB;IACzB,wBAAwB;IACxB,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB","sourcesContent":["@media screen and (max-width: 600px) {\n    .communityContainer {\n        min-height: 100vh;\n        padding: 20px;\n        font-family: \"Nunito Sans\", sans-serif;\n        background-color: #f5f5f5;\n        margin-top: -4rem;\n    }\n\n    .communityHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n    }\n\n    .userDetails {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .communityAvatar {\n        width: 45px;\n        height: 45px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        font-weight: 700;\n        color: white;\n    }\n\n    .userInfo {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 2px;\n    }\n\n    .userName {\n        font-size: 15px;\n        font-weight: 600;\n        color: rgba(33, 33, 33, 1);\n        font-family: 'Nunito Sans', Sans-serif, serif;\n    }\n\n    .createdDate {\n        font-size: 14px;\n        color: rgba(77, 77, 77, 1);\n        margin-top: 2px;\n        font-weight: 400;\n        font-family: 'Nunito Sans', Sans-serif, serif;\n    }\n\n    .answersSection {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        font-size: 14px;\n        margin-top: -6%;\n        gap: 10px;\n    }\n\n    .copyLinkIcon {\n        height: 20px;\n        color: rgba(77, 77, 77, 1);\n        background-color: rgba(245, 245, 245, 1);\n        padding: 7px;\n        border: 0 solid #555555;\n        border-radius: 16px;\n        cursor: pointer;\n    }\n\n    .questionsList {\n        display: flex;\n        flex-direction: column;\n        gap: -8px;\n    }\n\n    .questionCard {\n        padding: 15px;\n        padding-top: 20px;\n        background-color: #fff;\n        border-radius: 10px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        margin-top: 25px;\n        width: 91%;\n    }\n\n    .cardHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .actionButtons {\n        display: flex;\n        gap: 10px;\n        margin-right: 55%;\n    }\n\n    .actionIcon {\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n    }\n\n    .questionTitle {\n        font-size: 18px;\n        color: rgba(0, 75, 160, 1);\n        font-weight: 700;\n        margin: 25px 0 5px;\n        cursor: pointer;\n        font-family: 'Nunito Sans', Sans-serif, serif;\n\n    }\n\n    .description {\n        font-size: 14px;\n        font-weight: 400;\n        color: rgba(77, 77, 77, 1);\n        margin: 5px 0 0;\n        line-height: 1.5;\n        font-family: 'Nunito Sans', Sans-serif, serif;\n    }\n\n    .answersCount {\n        font-weight: bold;\n        margin-left: 54%;\n        color: black;\n        background-color: rgba(245, 245, 245, 1);\n        padding: 9px 19px;\n        border-radius: 16px;\n        font-size: 12px;\n    }\n\n    .currentUser .answersSection {\n        border-radius: 5px;\n        padding: 5px;\n        font-size: 14px;\n        color: #757575;\n        margin-top: -25px;\n    }\n\n    .currentUser .copyLinkIcon {\n        width: 20px;\n        height: 20px;\n    }\n\n    .defaultUser .answersSection {\n        background-color: #ffffff;\n        margin-top: -43px;\n    }\n\n    .defaultUser .copyLinkIcon {\n        width: 16px;\n        height: 16px;\n    }\n\n    .copiedText {\n        height: 20px;\n        width: 100%;\n        font-size: 10px;\n        color: lightslategray;\n        font-weight: bold;\n        margin-top: 10px;\n        display: inline-block;\n    }\n    .logoContainer {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n        top: 20px;\n        padding-bottom: 15px;\n        width: 100%;\n    }\n\n    .backArrow {\n        position: absolute;\n        left: 16px;\n        top: 2%;\n        cursor: pointer;\n    }\n\n    .SHlogo,\n    .backArrow {\n        height: 36px;\n    }\n\n    .SHlogo {\n        margin: 0 auto;\n        display: block;\n    }\n\n    .communityNavbar {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid white;\n        border-radius: 35px;\n        width: 95%;\n        margin: 15% auto;\n        gap: 6px;\n        background-color: rgba(255, 255, 255, 1);\n        height: 52px;\n    }\n\n    .communityNavbar p {\n        font-family: \"Nunito Sans\", sans-serif;\n        color: rgba(77, 77, 77, 1);\n        font-weight: 600;\n        font-size: 14px;\n        cursor: pointer;\n        padding: 8px 12px;\n        border-radius: 20px;\n    }\n\n    .communityNavbar p.active {\n        background-color: rgba(25, 118, 210, 0.12);\n        color: #1976D2;\n        padding: 10px 16px;\n        font-weight: 700;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    }\n\n    .communityNavbar p:hover {\n        background-color: rgba(25, 118, 210, 0.08);\n        color: #135ba0;\n    }\n\n}\n\n\n\n.community {\n    margin-top: -25px;\n    background-color: #F5F5F5;\n    position: relative;\n}\n.communityAccount {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 700;\n    color: white;\n    cursor: pointer;\n}\n.communityBanner{\n    background-image: linear-gradient(rgba(0, 0, 0.6, 0.6), rgba(0, 0, 0.6, 0.6)), url(\"../../../public/images/home_bg.jpg\");\n    background-color: #F5F5F5;\n    margin: 0 auto 60px auto;\n    width: 90%;\n    border-radius: 10px;\n    height: 230px;\n    background-repeat: no-repeat;\n    object-fit: cover;\n    background-size: 100%;\n    text-align: center;\n}\n.bannerTitle{\n    color: white;\n    font-size: 40px;\n    font-weight: bold;\n    margin: 0;\n    font-family: sans-serif;\n}\n.desc{\n    color: lightgrey;\n}\n.communityCount{\n    color: ghostwhite;\n    margin-bottom: 20px;\n}\n.communityHeading{\n    padding: 10px 0;\n    margin: 0;\n    text-align: center;\n}\n.searchContainer {\n    display: flex;\n    justify-content: center;\n    margin: 10px 0 20px 0;\n}\n.containerBody {\n    display: flex;\n    padding: 0 80px 40px 80px;\n    gap: 20px;\n    justify-content: center;\n    overflow: hidden;\n}\n.sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.contactUsBox {\n    font-size: 14px;\n    padding: 10px;\n    line-height: 5px;\n    text-align: center;\n    background-color: white;\n    border-radius: 15px;\n}\n.searchWrapper {\n    background-color: white;\n    height: 38px;\n    border-radius: 22px;\n}\n.communityHide {\n    display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"communityContainer": `OmL0k1siDBYnZFcDCGRA`,
	"communityHeader": `Tv6qA2o9NmhzzT6moi3l`,
	"userDetails": `aCuUKL3tNvTSewk9CUI5`,
	"communityAvatar": `E7N4bcgOnRZlI91eZLjE`,
	"userInfo": `SlKxh3LdKUwkgx8hUb3N`,
	"userName": `HvyUkA3pUczA5sLQGEhj`,
	"createdDate": `faujMG9wZP2vYdw0M1vq`,
	"answersSection": `AaX1fIXYpfSeoFerwDaf`,
	"copyLinkIcon": `QJ5m6ojPbeSpGPsT9MYW`,
	"questionsList": `pls963bgjTppYESE8Evm`,
	"questionCard": `Z9xrRCkgWPPSvCSedC4o`,
	"cardHeader": `CZbtrATtIdUaSS30xFQq`,
	"actionButtons": `BUceoThRp7MbfiTpW8iX`,
	"actionIcon": `AmlqCwQvuhtuYtDOpVrl`,
	"questionTitle": `ivmIKCTwLmdYEF0RVBgL`,
	"description": `yzGPhd7CjYvNTY6ssK2X`,
	"answersCount": `n5jnNnco_orTsH6WNyZU`,
	"currentUser": `l9Mro0JLxxkpw3vc0VsQ`,
	"defaultUser": `cDTrdXn9Jgcx5vBtquAN`,
	"copiedText": `n7cACY4adqQcH0HLUluf`,
	"logoContainer": `MAR7sEF73jMtrgpXm2Gd`,
	"backArrow": `HOxveBXEo4M2dA77bQLH`,
	"SHlogo": `Kv42rkZok22_plGpHFmU`,
	"communityNavbar": `ZMBhr4sIHOeShyiFhZ3d`,
	"active": `stVkduZD3MUjoXboSTgk`,
	"community": `aDkAGkcAr4kipXJWr846`,
	"communityAccount": `tV8D8bekuMLBItOytzPC`,
	"communityBanner": `Z886TPaOVv9Slu5UxMdg`,
	"bannerTitle": `m5VIelB54f6NAoS_9kIR`,
	"desc": `cNpPzvaE13owUS_z5sMF`,
	"communityCount": `BnCccvejn0Izkne6dwj4`,
	"communityHeading": `CUUi3lMEOplbshk0BMqh`,
	"searchContainer": `h2t_7THSlfsAwV5H_spW`,
	"containerBody": `GLfLORnKxMSSDmrutRjf`,
	"sidebar": `nSKs8tl3O6dhGzhQSVpP`,
	"contactUsBox": `A7ivpXKRI8lCuJezktV_`,
	"searchWrapper": `IH40yGfeI8pO2Rjv3DHP`,
	"communityHide": `HNr6iN3rXKpb9Ye0qfeZ`
};
export default ___CSS_LOADER_EXPORT___;
